import ApiService from './api.service'
import { APP_ID } from '../_helpers/config'

export default class AuthService {
  static resource = 'auth'

  static login(credientials) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.resource}/login`, { ...credientials, appId: APP_ID })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  static signup(credientials) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.resource}/signup`, { ...credientials, appId: APP_ID })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  static forgotPassword(credientials) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.resource}/forgotpassword`, { ...credientials, appId: APP_ID })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
